import Button from 'shared/ui/Button';
import React from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { newPipeline } from 'store/Pipelines/actions';
import { Wrapper, Title, EmptyImage } from './styled';

const Empty = () => {
  const intl = useIntl();
  const dispatch = useDispatch();

  return (
    <Wrapper>
      <EmptyImage />
      <Title>{ intl.formatMessage({ id: 'pipelines.empty.title' }) }</Title>
      <Button onClick={ () => dispatch(newPipeline()) }>Create a Pipeline</Button>
    </Wrapper>
  );
};
export default Empty;
